<template>
  <BaseModal
    :id="modalId"
    title="Video Conference Visibility"
    :size="'md'"
    @closeModal="closeModal"
    @openModal="openModal"
  >
    <div>
      <label for="input-status" class="mb-u4"> Status </label>
      <b-alert show variant="info"> Bangkok Time </b-alert>
      <div class="mt-u6">
        <b-form-radio v-model="isPublished" :value="false"> Unpublished </b-form-radio>
        <b-form-radio v-model="isPublished" :value="true" class="mt-u4">
          <div>Published</div>
        </b-form-radio>
        <BaseDatePicker
          :existed-data="publishedAt"
          date-picker-class="w-100 mb-3"
          class="ml-u8 mt-u3"
          @emitDate="
            (date) => {
              publishedAt = date;
            }
          "
        />
      </div>
    </div>
    <template slot="modal-footer">
      <b-button variant="link" class="btn-link-dark" @click="hide"> Cancel </b-button>
      <b-button variant="success" @click="onSave">
        <span v-if="!isLoading">Save</span>

        <span v-else class="pr-2 pl-2">
          <b-spinner label="Loading..." variant="secondary" small />
        </span>
      </b-button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base-components/BaseModal';
import Post from '@/models/Post';
import PostSchedule from '@/models/PostSchedule';
import BaseDatePicker from '@/components/base-components/BaseDatePicker.vue';

export default {
  components: {
    BaseModal,
    BaseDatePicker
  },

  props: {
    postId: {
      type: Number,
      required: true
    },

    postSchedule: {
      type: PostSchedule,
      default: () => ({})
    }
  },

  data() {
    return {
      isPublished: false,
      isLoading: false,
      publishedAt: null
    };
  },

  computed: {
    modalId() {
      return `modalPublishPost-${this.postId}`;
    },

    $_isPublished: {
      get() {
        return this.isPublished;
      },

      set(v) {
        this.$emit('change', v);

        return this;
      }
    }
  },

  mounted() {
    this.isPublished = this.postSchedule.published_at ? true : false;
    this.publishedAt = this.postSchedule.published_at
      ? this.postSchedule.published_at
      : new Date().toString();
  },

  methods: {
    notiPublishedVideoConference() {
      this.$toast.open({
        message: `The Video conference was successfully published.`,
        type: 'success',
        pauseOnHover: true
      });
    },

    async onSave() {
      this.isLoading = true;

      if (this.isPublished) {
        const published_at = this.isPublished ? this.publishedAt : null;
        try {
          await Promise.all([
            Post.api().updatePost(this.postId, {
              is_published: this.isPublished,
              published_at
            }),

            PostSchedule.api().update(this.postSchedule.id, {
              published_at,
              required_review: false,
              risPublisheviewed_at: published_at
            })
          ]);

          this.$_isPublished = this.isPublished;
          this.$emit('saveSuccessful');
          this.$toast.open({
            message: 'The Video conference was successfully published.',
            type: 'success',
            pauseOnHover: true
          });
        } catch (error) {
          console.error(error);
          this.$toast.open({
            message: `The Video conference cannot publish, please try again.`,
            type: 'error',
            duration: 5000
          });
        }
      }

      this.isLoading = false;

      this.hide();
    },
    closeModal() {
      this.isPublished = false;
      this.$emit('closeModal', true);
    },
    openModal() {
      this.isPublished = this.$_isPublished;
      this.$emit('openModal', true);
    },
    show() {
      this.$bvModal.show(this.modalId);
    },
    hide() {
      this.$bvModal.hide(this.modalId);
    }
  }
};
</script>

<style lang="scss" scoped></style>
